import { classNames } from '@repo/ui/src/utils/classNames';
import { headingClasses } from '@repo/ui/src/utils/styleUtils';
import { HeaderVariationProps } from '@repo/ui/src/types/headerVariation';

interface Props {
  subtitleAsDesc?: boolean;
  subtitle?: string;
  title?: string;
  headerVariation: HeaderVariationProps;
  darkMode: boolean;
  description?: string;
}

const TierTwoHeader = ({
  subtitleAsDesc,
  subtitle,
  title,
  headerVariation,
  darkMode,
  description,
}: Props) => {
  const Header = headerVariation?.headerVariation ?? 'h1';
  const newDesc = subtitleAsDesc ? subtitle : description;

  return (
    <>
      <div>
        {!subtitleAsDesc && subtitle && (
          <h2
            className={classNames(
              'max-w-[600px] tra-text-web-sub-1 pt-0 pb-3 m-auto',
              darkMode ? 'text-white' : 'text-black',
            )}
          >
            {subtitle}
          </h2>
        )}
        {title && (
          <Header
            className={classNames(
              'tra-text-web-heading-1 py-0',
              darkMode ? 'text-white' : 'text-black',
              headingClasses[Header],
            )}
          >
            {title}
          </Header>
        )}
      </div>
      {newDesc && (
        <p
          className={classNames(
            'tra-text-web-body-xl max-w-[600px]',
            darkMode ? 'text-white' : 'text-black',
          )}
        >
          {newDesc}
        </p>
      )}
    </>
  );
};

export default TierTwoHeader;
